import { Input, InputRef } from "antd";
import React, { forwardRef, useCallback } from "react";

import { StyledFormItem, standardFormItemCols } from "./styles";

type Props = {
  value: string;
  onChange: (value: string) => void;
  onBlur?: (event: React.FocusEvent<HTMLInputElement>) => void;
  label: string;
  required?: string;
  extra?: React.ReactNode;
  styledFormItemProps?: React.ComponentProps<typeof StyledFormItem>;
};

// @TODO: Support additional validation rules
export const FormInput = forwardRef<InputRef, Props>(
  (
    {
      value,
      onChange,
      onBlur,
      label,
      required,
      extra,
      styledFormItemProps = standardFormItemCols,
    },
    ref
  ) => {
    const handleChange = useCallback(
      (e: React.ChangeEvent<HTMLInputElement>) => {
        onChange(e.target.value);
      },
      [onChange]
    );

    return (
      <StyledFormItem
        label={label}
        rules={[
          {
            required: Boolean(required),
            message: required,
          },
        ]}
        {...styledFormItemProps}
      >
        <Input
          value={value}
          ref={ref}
          onChange={handleChange}
          onBlur={onBlur}
        />
        {extra}
      </StyledFormItem>
    );
  }
);

FormInput.displayName = "FormInput";
